/**
 * OTC 成交记录（admin view of GET /api/admin/otc/trades）。
 *
 * 只读，按照 buyer_id / seller_id / order_id 过滤。成交记录不可改，
 * 没有操作列。用来替代旧 EasyAdmin 的 uo_bonus_log 成交子页。
 */
import { useState } from 'react';
import { Input, Space, Tag } from 'antd';
import { DataTable } from '../../components/DataTable';

interface OtcTradeRow {
  id: string;
  buy_order_id: string;
  sell_order_id: string;
  buyer_id: number;
  seller_id: number;
  amount_uo: string;
  unit_price: string;
  amount_ap: string;
  fee_ep_buyer: string;
  fee_ep_seller: string;
  create_time: string;
}

export function OtcTradesPage() {
  const [userId, setUserId] = useState<string>('');
  const [orderId, setOrderId] = useState<string>('');

  const columns = [
    { title: '成交 ID', dataIndex: 'id', width: 110 },
    {
      title: '买单 ID',
      dataIndex: 'buy_order_id',
      width: 110,
      render: (v: string) => <Tag color="green">{v}</Tag>,
    },
    {
      title: '卖单 ID',
      dataIndex: 'sell_order_id',
      width: 110,
      render: (v: string) => <Tag color="red">{v}</Tag>,
    },
    { title: '买家', dataIndex: 'buyer_id', width: 90 },
    { title: '卖家', dataIndex: 'seller_id', width: 90 },
    { title: '数量 (ORB)', dataIndex: 'amount_uo', width: 130 },
    { title: '成交价 (AP)', dataIndex: 'unit_price', width: 120 },
    { title: '总额 (AP)', dataIndex: 'amount_ap', width: 130 },
    { title: '买家手续费 (EP)', dataIndex: 'fee_ep_buyer', width: 140 },
    { title: '卖家手续费 (EP)', dataIndex: 'fee_ep_seller', width: 140 },
    { title: '成交时间', dataIndex: 'create_time', width: 170 },
  ];

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>ORB 成交记录</h2>
      <Space style={{ marginBottom: 12 }} wrap>
        <Input
          placeholder="按会员 ID（买家或卖家）"
          style={{ width: 200 }}
          allowClear
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
        <Input
          placeholder="按订单 ID"
          style={{ width: 160 }}
          allowClear
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
        />
      </Space>
      <DataTable<OtcTradeRow>
        queryKey={['admin', 'otc-trades', userId, orderId]}
        endpoint="/api/admin/otc/trades"
        extraParams={{
          user_id: userId ? Number(userId) : undefined,
          order_id: orderId ? Number(orderId) : undefined,
        }}
        columns={columns}
        rowKey="id"
        scroll={{ x: 1600 }}
      />
    </div>
  );
}
